import { FC } from "react";
import ContentLoader from "react-content-loader";

const CardAttendanceLoader: FC = props => (
	<ContentLoader
		style={{ minWidth: 310 }}
		speed={2}
		width={"100%"}
		height={135}
		viewBox="0 0 310 135"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb"
		{...props}
	>
		<circle cx="45" cy="32" r="25" />
		<rect x="80" y="13" rx="0" ry="0" width="220" height="12" />
		<rect x="80" y="34" rx="0" ry="0" width="103" height="12" />
		<rect x="215" y="40" rx="5" ry="5" width="85" height="15" />
		<rect x="22" y="65" rx="0" ry="0" width="277" height="1" />
		<rect x="22" y="75" rx="7" ry="7" width="90" height="25" />
		<rect x="121" y="75" rx="7" ry="7" width="85" height="25" />
		<rect x="215" y="75" rx="7" ry="7" width="85" height="25" />
	</ContentLoader>
);

export default CardAttendanceLoader;
